import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import BranchReportLayer from "../../../components/Admin/BranchReportLayer";

const BranchReport = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <BranchReportLayer />
      </MasterLayout>
    </>
  );
};

export default BranchReport